import { ReleaseTextModal } from "./ReleaseTextModal";

export default ReleaseTextModal;
